import { hashTarget, jumpTo, unmodifiedActivation } from './anchors';

// Preserve native modified clicks and move reading focus when following a fragment.
document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('a[href^="#"]').forEach(link => {
        if (link.matches('.skip-link, .coto-skip-page-links') || link.closest('.content-overview-list')) return;
        link.addEventListener('click', event => {
            if (!unmodifiedActivation(event) || !link.hash) return;
            const target = hashTarget(link.hash);
            if (!target) return;
            event.preventDefault();
            jumpTo(target, { hash: link.hash, keyboard: event.detail === 0 });
        });
    });
});
